import { observer, use$ } from '@legendapp/state/react';
import { SAMPLE, oppMeta, statusMeta, momMeta } from '../data/sample';
import { state$, openFunc } from '../state';

export const Opportunities = observer(function Opportunities() {
  const expandedOpp = use$(state$.expandedOpp);
  const d = SAMPLE;
  const ranked = [...d.functions].sort((a, b) => b.opp.score - a.opp.score);

  return (
    <div
      style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 18, alignItems: 'start' }}
    >
      <div>
        <div style={{ marginBottom: 14 }}>
          <h2 style={{ fontSize: 17, fontWeight: 700, margin: '0 0 3px' }}>
            Functions half-built & worth doing
          </h2>
          <p style={{ margin: 0, fontSize: 13, color: '#6d7175' }}>
            High opportunity = people are asking, no one does it well, and someone will pay. Three
            conditions, not one.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 11 }}>
          {ranked.map((f, i) => {
            const om = oppMeta(f.opp.score);
            const st = statusMeta(f.status);
            const ev = d.oppEvidence[f.id] ?? { complaints: [], gatedBy: [] };
            const exp = expandedOpp === f.id;
            const components = [
              { label: 'Demand', value: f.opp.demand },
              { label: 'Quality gap', value: f.opp.gap },
              { label: 'Monetization', value: f.opp.monet },
            ];
            return (
              <div
                key={f.id}
                style={{
                  background: '#fff',
                  border: `1px solid ${exp ? '#d9d9d9' : '#e1e3e5'}`,
                  borderRadius: 14,
                  overflow: 'hidden',
                  animation: 'nl-rise .3s ease',
                }}
              >
                <div
                  onClick={() => state$.expandedOpp.set(exp ? null : f.id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 15,
                    padding: '16px 18px',
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      flexShrink: 0,
                      width: 40,
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "'JetBrains Mono'",
                        fontSize: 11,
                        color: '#b4b9c2',
                        fontWeight: 600,
                      }}
                    >
                      #{i + 1}
                    </span>
                    <div
                      style={{
                        fontFamily: "'JetBrains Mono'",
                        fontSize: 23,
                        fontWeight: 700,
                        color: om.fg,
                        lineHeight: 1,
                      }}
                    >
                      {f.opp.score}
                    </div>
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 9 }}>
                      <span style={{ fontSize: 14.5, fontWeight: 700 }}>{f.name}</span>
                      <span
                        style={{
                          padding: '1px 7px',
                          borderRadius: 6,
                          background: st.bg,
                          color: st.fg,
                          fontSize: 10,
                          fontWeight: 700,
                        }}
                      >
                        {st.label}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: 14 }}>
                      {components.map((c) => (
                        <div key={c.label} style={{ flex: 1 }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              fontSize: 10.5,
                              color: '#6d7175',
                              fontWeight: 600,
                              marginBottom: 3,
                            }}
                          >
                            <span>{c.label}</span>
                            <span style={{ fontFamily: "'JetBrains Mono'", color: '#6d7175' }}>
                              {c.value}
                            </span>
                          </div>
                          <div
                            style={{
                              height: 5,
                              borderRadius: 4,
                              background: '#ebebeb',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              style={{
                                height: '100%',
                                width: `${c.value}%`,
                                background: '#9aa0a6',
                                borderRadius: 4,
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <span
                    style={{
                      fontSize: 13,
                      color: '#b4b9c2',
                      flexShrink: 0,
                      transform: `rotate(${exp ? '180deg' : '0deg'})`,
                      transition: 'transform .2s',
                    }}
                  >
                    ▾
                  </span>
                </div>
                {exp && (
                  <div
                    style={{
                      padding: '16px 18px 18px',
                      borderTop: '1px dashed #e1e3e5',
                      marginTop: -2,
                      animation: 'nl-fade .25s ease',
                    }}
                  >
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18 }}>
                      <div>
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: '#d72c0d',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            marginBottom: 9,
                          }}
                        >
                          Complaint clusters
                        </div>
                        {ev.complaints.map((cp, ci) => (
                          <div
                            key={ci}
                            style={{
                              display: 'flex',
                              gap: 8,
                              marginBottom: 8,
                              fontSize: 12.5,
                              color: '#616161',
                              lineHeight: 1.45,
                            }}
                          >
                            <span style={{ color: '#d72c0d', flexShrink: 0 }}>"</span>
                            <div>
                              {cp.text}{' '}
                              <span
                                style={{
                                  fontFamily: "'JetBrains Mono'",
                                  fontSize: 11,
                                  color: '#a5abb5',
                                }}
                              >
                                · {cp.count}×
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div>
                        <div
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            color: '#303030',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            marginBottom: 9,
                          }}
                        >
                          Monetization evidence
                        </div>
                        {ev.gatedBy.map((g, gi) => (
                          <div
                            key={gi}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              marginBottom: 8,
                              fontSize: 12.5,
                              color: '#616161',
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "'JetBrains Mono'",
                                fontSize: 10,
                                fontWeight: 700,
                                color: '#303030',
                                background: '#eef0f2',
                                borderRadius: 4,
                                padding: '1px 5px',
                              }}
                            >
                              $
                            </span>
                            {g.text}
                          </div>
                        ))}
                      </div>
                    </div>
                    <button
                      onClick={() => openFunc(f.id)}
                      style={{
                        marginTop: 14,
                        height: 34,
                        padding: '0 14px',
                        background: '#f1f1f1',
                        border: '1px solid #e1e3e5',
                        borderRadius: 8,
                        fontFamily: 'inherit',
                        fontSize: 12.5,
                        fontWeight: 600,
                        color: '#616161',
                        cursor: 'pointer',
                      }}
                    >
                      See function detail (cross-app) →
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* unmet demand */}
      <div
        style={{
          background: 'linear-gradient(165deg,#fff,#fff8ef)',
          border: '1px solid #f0e0c0',
          borderRadius: 16,
          padding: 20,
          position: 'sticky',
          top: 78,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#b98900' }} />
          <h3 style={{ fontSize: 15, fontWeight: 700, margin: 0 }}>Unmet demand</h3>
        </div>
        <p style={{ margin: '0 0 16px', fontSize: 12.5, color: '#8a6116', lineHeight: 1.5 }}>
          Feature requests that map to no existing function — the purest opportunity.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
          {d.unmet.map((u, i) => {
            const mm = momMeta(u.trend);
            return (
              <div
                key={i}
                style={{
                  background: '#fff',
                  border: '1px solid #ece0cb',
                  borderRadius: 11,
                  padding: '12px 13px',
                }}
              >
                <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.35, marginBottom: 7 }}>
                  {u.label}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11.5 }}>
                  <span style={{ fontFamily: "'JetBrains Mono'", color: '#6d7175' }}>
                    {u.count} mentions
                  </span>
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 3,
                      fontWeight: 700,
                      color: mm.fg,
                    }}
                  >
                    <span style={{ fontFamily: "'JetBrains Mono'" }}>{mm.arrow}</span>
                    {mm.label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});
